import { computed } from 'vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { useAccount } from './useAccount';

export function usePublishedArticlesQuota() {
  const { currentAccount, isCloudFeatureEnabled } = useAccount();

  const helpCenterEnabled = computed(() =>
    isCloudFeatureEnabled(FEATURE_FLAGS.HELP_CENTER)
  );

  const remaining = computed(() => {
    const dim = currentAccount.value?.limits?.published_articles;
    if (!dim || dim.allowed == null) return null;
    const value = dim.remaining ?? dim.allowed - (dim.consumed ?? 0);
    return Math.max(0, value);
  });

  const articlesQuotaExhausted = computed(() => remaining.value === 0);

  const canCreateHelpCenter = computed(() => helpCenterEnabled.value);

  const canAddArticles = computed(
    () => canCreateHelpCenter.value && remaining.value !== 0
  );

  return {
    helpCenterEnabled,
    remaining,
    articlesQuotaExhausted,
    canCreateHelpCenter,
    canAddArticles,
  };
}
